import { Distance } from 'models';

function distanceToSelectItem(distance: Distance): NewSelectItemType {
  return { key: distance.value.id, value: distance.value.id, label: distance.title() };
}

export { distanceToSelectItem };
